import { ref, computed, onMounted, onUnmounted } from 'vue'

/**
 * Drives a soft spotlight overlay via CSS custom properties.
 * Per-card variation: angle + resting highlight position.
 */
export function useCardSheen() {
  const angle = 115 + Math.floor(Math.random() * 70)
  const restX = 14 + Math.floor(Math.random() * 34)
  const restY = 10 + Math.floor(Math.random() * 28)

  const root = ref(null)
  const mx = ref(restX)
  const my = ref(restY)
  const targetMx = ref(restX)
  const targetMy = ref(restY)
  const hovering = ref(false)

  let rafId = null

  const surfaceStyle = computed(() => ({
    '--sheen-x': `${mx.value}%`,
    '--sheen-y': `${my.value}%`,
    '--sheen-angle': `${angle}deg`,
    '--sheen-active': hovering.value ? '1' : '0',
  }))

  function tick() {
    const dx = targetMx.value - mx.value
    const dy = targetMy.value - my.value

    if (Math.abs(dx) > 0.12 || Math.abs(dy) > 0.12) {
      mx.value += dx * 0.18
      my.value += dy * 0.18
      rafId = requestAnimationFrame(tick)
    } else {
      mx.value = targetMx.value
      my.value = targetMy.value
      rafId = null
    }
  }

  function scheduleTick() {
    if (rafId == null) {
      rafId = requestAnimationFrame(tick)
    }
  }

  function onPointerMove(event) {
    if (!root.value) return
    const rect = root.value.getBoundingClientRect()
    targetMx.value = Math.min(100, Math.max(0, ((event.clientX - rect.left) / rect.width) * 100))
    targetMy.value = Math.min(100, Math.max(0, ((event.clientY - rect.top) / rect.height) * 100))
    hovering.value = true
    scheduleTick()
  }

  function onPointerEnter(event) {
    onPointerMove(event)
  }

  function onPointerLeave() {
    hovering.value = false
    targetMx.value = restX
    targetMy.value = restY
    scheduleTick()
  }

  onMounted(() => {
    mx.value = restX
    my.value = restY
    targetMx.value = restX
    targetMy.value = restY
  })

  onUnmounted(() => {
    if (rafId != null) {
      cancelAnimationFrame(rafId)
    }
  })

  return {
    root,
    surfaceStyle,
    onPointerMove,
    onPointerEnter,
    onPointerLeave,
  }
}